import httpService from './core/http.service';

class CompaniesService {
    /**
     * Creates a company from a name and a first user. Everything else comes from the server's
     * documented default set (CompanyDefaults) and can be changed afterwards on the company page.
     */
    createLean(body) {
        return httpService.post('/companies/lean', body);
    }

    listApiKeys(companyId) {
        return httpService.get(`/companies/${companyId}/api-keys`);
    }

    createApiKey(companyId, body) {
        return httpService.post(`/companies/${companyId}/api-keys`, body);
    }

    rotateApiKey(companyId, keyId) {
        return httpService.post(`/companies/${companyId}/api-keys/${keyId}/rotate`);
    }

    deleteApiKey(companyId, keyId) {
        return httpService.delete(`/companies/${companyId}/api-keys/${keyId}`);
    }
}

export default new CompaniesService();
